export const Constants = {
    API_DEFAULT: 'sgsia',
    VERSION_DEFAULT: '1.0.0',
    NUM_REGISTRO_POR_PAGINA: 10
};
